/**
 * `32.1` (`ФЗ-152`, `DEV-65`): **старый ключ пароля удаляется при старте
 * приложения**, а не при открытии формы входа.
 *
 * `п. 32` убрал пароль из хранилища страницы: «запомнить меня» хранит только
 * адрес. Но чистка прежнего ключа стояла в самих формах, а форму входа человек,
 * уже вошедший (или вошедший с чужой машины и не выходивший), не открывает
 * вовсе — ключ с паролем так и лежал бы в браузере. Поэтому чистка переехала на
 * старт приложения: она выполняется до `checkAuth`, то есть до первого обращения
 * к серверу за сессией, и ждать открытия формы не нужно.
 *
 * Почему отдельно от формы: у чистки один смысл — «прежний ключ не должен
 * дожить до работы с системой». Место, где это гарантировано, — загрузка
 * приложения; форма входа лишь частный случай того, что загружается.
 */

/** Прежнее имя ключа: именно его писал сайт до `п. 32`. */
export const LEGACY_PASSWORD_KEY = "password";

/**
 * Убрать прежний ключ пароля. Идемпотентно: ключа нет — ничего не происходит,
 * остальное содержимое хранилища (адрес, отметка «запомнить меня», служебные
 * признаки) не трогается, сессия живёт в httpOnly-cookie и от хранилища не
 * зависит.
 */
export function forgetLegacyPasswordKey(): void {
  try {
    window.localStorage.removeItem(LEGACY_PASSWORD_KEY);
  } catch {
    // Хранилище может быть недоступно (приватный режим, запрет настроек браузера).
    // Это не повод не поднять приложение: ключа в этом случае и не прочитать.
  }
}
